import htmx from "htmx.org"

const HOME_VIEW_ID = "home-view-container"
const PAGE_UPDATED_EVENT = "PAGE_UPDATED"

declare global {
  interface Window {
    pageSSE: EventSource | null
    initPageSSE: () => void
  }
}

window.pageSSE = null

window.initPageSSE = () => {
  const isStaff = document.getElementById("page")?.classList.contains("page--STAFF")
  if (!isStaff) {
    return
  }

  const container = document.getElementById(HOME_VIEW_ID)
  const pageId = container?.getAttribute("data-page-id")

  if (!pageId) {
    return
  }

  if (window.pageSSE) {
    window.pageSSE.close()
    window.pageSSE = null
  }

  window.pageSSE = new EventSource(`${window.APP_BASE_URL}/api/pages/open-sse?pageId=${pageId}`)

  window.pageSSE.onmessage = (e: MessageEvent) => {
    const event = JSON.parse(e.data as string)
    if (event.type === PAGE_UPDATED_EVENT) {
      htmx.ajax("get", `/partials/custom-pages/${pageId}/home-view`, {})
    }
  }
}
